var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1722_51513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 13.5002H3C2.86739 13.5002 2.74022 13.4475 2.64645 13.3537C2.55268 13.26 2.5 13.1328 2.5 13.0002V10.2064C2.49978 10.1415 2.51236 10.0772 2.53702 10.0171C2.56169 9.95707 2.59796 9.90246 2.64375 9.85644L10.1438 2.35644C10.1903 2.3092 10.2457 2.27168 10.3069 2.24607C10.3681 2.22046 10.4337 2.20728 10.5 2.20728C10.5663 2.20728 10.632 2.22046 10.6931 2.24607C10.7543 2.27168 10.8097 2.3092 10.8563 2.35644L13.6438 5.14394C13.691 5.19046 13.7285 5.24592 13.7541 5.30708C13.7797 5.36824 13.7929 5.43388 13.7929 5.50019C13.7929 5.56649 13.7797 5.63214 13.7541 5.6933C13.7285 5.75446 13.691 5.80991 13.6438 5.85644L6 13.5002Z",
    stroke: "#4E83E4",
    strokeWidth: 1.50026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.5002H6",
    stroke: "#4E83E4",
    strokeWidth: 1.50026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4L12 7.5",
    stroke: "#4E83E4",
    strokeWidth: 1.50026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1722_51513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.5dfe41b27567a24136ec4d0825437cb7.svg";
export { ForwardRef as ReactComponent };